import { render } from "./RelatorioCliente.vue?vue&type=template&id=791be426"
import script from "./RelatorioCliente.vue?vue&type=script&lang=js"
export * from "./RelatorioCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__